import { Toggle } from '../Toggle.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { action } from '../../lib/actionHelpers.js';

const ToggleFilterItem = ({ item }) => {
  const filterValue = useSelector((state) => state.ui.filters[item.id || item.type]);

  const handleToggleChange = () => {
    action('uiPatchFilters', {
      [item.id || item.type]: !filterValue,
    });
  };

  return <Toggle label={item.label} toggle={filterValue || false} onChange={handleToggleChange} />;
};

export default ToggleFilterItem;
